module.exports = __webpack_public_path__ + "static/media/78.6e771957.jpg";